import React, { useState } from "react";
import CargoDetailsBlock from "./CargoDetailsBlock";
import CargoSendUpdateDialog from "view/cargos/components/dialogs/CargoSendUpdateDialog";
import { Height, LoadingBlock } from "../Blocks";
import { SalesCharter } from "types/index";
import { ContactRoleType, SalesCharterStatus } from "__generated__/graphql";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";

type UseCargoBlockProps = {
	charter?: SalesCharter;
	loading: boolean;
	refetch: () => void;
};

const useCargoBlock = ({ charter, loading, refetch }: UseCargoBlockProps) => {
	const [ sendUpdateDialogOpen, setSendUpdateDialogOpen ] = useState(false);

	return {
		cargoBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Auto} />
				);
			} else if (charter) {
				return (
					<>
						<CargoDetailsBlock
							charter={charter}
							color={getCharterTypeColor(charter.type, charter.subtype)}
							refetch={refetch}
							openEmailDialog={() => {
								if (charter.status && [ SalesCharterStatus.Confirmed, SalesCharterStatus.Planned, SalesCharterStatus.InProgress ].includes(charter.status.name)) {
									setSendUpdateDialogOpen(true);
								}
							}} />

						<CargoSendUpdateDialog
							open={sendUpdateDialogOpen}
							onClose={() => setSendUpdateDialogOpen(false)}
							customer={{
								name: charter.debtor.name,
								contacts: charter.contacts?.filter(x => x.contactRoleType === ContactRoleType.NominationAndConfirmation).map(x => x.contact) ?? [] }
							}
							voyage={charter.voyages?.[0]}
							charterId={charter.id}
						/>
					</>
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),
	};
};

export default useCargoBlock;
